import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {baseStyles, BORDER_RADIUS, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Space from "../commons/Space";
import {Button, GridList, Typography} from "@material-ui/core";
import {ACTIVITY_TYPES_MODEL, ACTIVITY_USAGE_TYPES_MODEL} from "../admin/management/activities/ActivityLists";
import {ColorCard, ColorCardXS} from "src/styles/Colors";
import {FormattedMessage} from "react-intl";

const useStyles = (theme) => ({
  usageCardWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  usageCardButtonBase: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    minHeight: 100,
    backgroundColor: ColorCard,
    [theme.breakpoints.down('xs')]: {
      backgroundColor: ColorCardXS,
      minHeight: 70,
    },
  },
  usageCardImage: {
    width: 44,
    height: 44,
    [theme.breakpoints.down('xs')]: {
      width: 36,
      height: 36,
    }
  },
});

class ManageActivityUsage extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    const activityTypes = this.getActivityTypes(activityData.usageType);

    this.state = {
      activityType: activityData.activityType,
      usageType: activityData.usageType,
      preferredActivityTypes: activityTypes[0],
      otherActivityTypes: activityTypes[1],
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    const {
      usageType,
    } = this.state;

    if (!excludeError) {
      if (!usageType) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    return {
      usageType
    };
  }

  render() {
    const {classes, isXS, app, isDrawerHidden} = this.props;
    const {showValidationMsg, activityType, usageType, preferredActivityTypes, otherActivityTypes} = this.state;

    let activityUsageTypeError = null;
    if (showValidationMsg) {
      if (!usageType) {
        activityUsageTypeError = this.context.intl.formatMessage({id: 'campaign.selectUsageType'});
      }
    }

    let columns = 3;
    if (isXS) {
      columns = 1;
    } else if (isDrawerHidden) {
      columns = 2;
    }
    const spacing = isXS ? 6 : 8;

    return (
      <div className={classes.flexColumn}>
        <GridList cols={columns} className={classes.usageCardWrapper} cellHeight={'auto'}>
          {ACTIVITY_USAGE_TYPES_MODEL.map((item, index) => {
            const x = Math.floor(index / columns);
            const y = index % columns;
            const padding = spacing;
            const paddingTop = x === 0 ? 0 : spacing;
            const paddingLeft = (app.isLTR ? y === 0 : y === columns-1) ? 0 : spacing;
            const paddingRight = (app.isLTR ? y === columns-1 : y === 0) ? 0 : spacing;
            return (
              <div style={{padding: padding}}>
                <div
                  key={item.id +'-'+ padding +'-'+ paddingTop +'-'+ paddingLeft +'-'+ paddingRight}
                  className={classes.usageCardButtonBase} style={{height: '100%'}}>
                  <div className={classes.flexColumnNoCenter}>
                    <img className={classes.usageCardImage} src={item.image}/>
                    <Space horizontal={isXS ? 8 : 12}/>
                    <div className={classes.viewRowFullWidthNoCenter}>
                      <div className={classes.flexColumnNoCenter}>
                        <Typography align={'left'} variant={isXS ? "subtitle2" : "subtitle1"} color="textPrimary" className={classes.typoMedium}>
                          {item.name}
                        </Typography>
                        <Space horizontal={isXS ? 1 : 2}/>
                        <Typography align={'left'} variant={isXS ? "caption" : "body2"} color="textSecondary">
                          {item.details}
                        </Typography>
                      </div>
                      <Space verticalSpace={1}/>
                      <Button
                        disableElevation={true}
                        color={'primary'}
                        variant={'contained'}
                        onClick={this.onActivityUsageTypeSelected.bind(this, item)}
                        style={{marginBottom: 4, alignSelf: 'flex-end'}}>
                        <FormattedMessage id={'activity.start'} />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </GridList>
        {/*{activityUsageTypeError && <FormHelperText className={classes.helperError}>{activityUsageTypeError}</FormHelperText>}*/}
      </div>
    )
  }

  onActivityUsageTypeSelected = (item) => {
    this.setState({usageType: item.id, showValidationMsg: false}, () => {
      if (this.props.moveNext) {
        this.props.moveNext();
      }
    });
  }

  getActivityTypes(usageType) {
    let preferredTypeIds = null;
    if (usageType) {
      preferredTypeIds = [1, 11, 15];
    }
    let otherTypes = null;
    let preferredTypes = null;
    if (preferredTypeIds) {
      preferredTypes = [];
      ACTIVITY_TYPES_MODEL.forEach((item) => {
        if (preferredTypeIds.includes(item.id)) {
          preferredTypes.push(item);
        }
      });
    }
    if (preferredTypes) {
      otherTypes = ACTIVITY_TYPES_MODEL.filter((item) => !preferredTypes.includes(item));
    } else {
      otherTypes = ACTIVITY_TYPES_MODEL;
    }
    return [preferredTypes, otherTypes];
  }

}

ManageActivityUsage.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  categories: PropTypes.array,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
  fetchBusinesses: PropTypes.func,
};

ManageActivityUsage.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
  ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}]
])(ManageActivityUsage)));
